/** Column config for Auditing → Inventory (stock-adjustment rows). */

import type { InventoryReportingExportColumnKey } from '../../types/reporting';

export const AUDIT_INVENTORY_COLUMN_KEYS: string[] = [
    'name',
    'manufacturerPartNumber',
    'category',
    'partType',
    'unit',
    'roNumber',
    'bins',
    'tags',
    'locationTitle',
    'supplierName',
    'businessLine',
    'timestamp',
    'quantity',
    'inStockQuantityAfter',
    'orderedAndInitialQuantity',
    'usedQuantity',
    'soldQuantity',
    'targetQuantity',
    'reorderQuantity',
    'unitCost',
    'lineCost',
    'adjustmentType',
    'note',
];

export const AUDIT_INVENTORY_DEFAULT_HIDDEN: string[] = [
    'category',
    'partType',
    'unit',
    'roNumber',
    'bins',
    'supplierName',
    'businessLine',
    'targetQuantity',
    'reorderQuantity',
    'unitCost',
    'adjustmentType',
];

export const AUDIT_INVENTORY_PINNED_KEYS: string[] = ['name'];

export const AUDIT_INVENTORY_LABELS: Record<string, string> = {
    name: 'Name',
    manufacturerPartNumber: 'Part Number',
    category: 'Category',
    partType: 'Part Type',
    unit: 'Unit',
    roNumber: 'RO Number',
    note: 'Note',
    bins: 'Bins',
    tags: 'Tags',
    locationTitle: 'Location',
    supplierName: 'Supplier',
    businessLine: 'Business Line',
    timestamp: 'Timestamp',
    quantity: '+/- Quantity',
    inStockQuantityAfter: 'In-Stock',
    orderedAndInitialQuantity: 'Added',
    usedQuantity: 'Used',
    soldQuantity: 'Sold',
    targetQuantity: 'Target Quantity',
    reorderQuantity: 'Reorder Quantity',
    unitCost: 'Unit Cost',
    lineCost: 'Net Transaction Value',
    adjustmentType: 'Adj. Type',
};

/** Labels for Table Settings drawer (may spell out abbreviated table headers). */
export const AUDIT_INVENTORY_SETTINGS_LABELS: Record<string, string> = {
    ...AUDIT_INVENTORY_LABELS,
    adjustmentType: 'Adjustment Type',
};

/** Allowlisted export keys from the inventory reporting API contract. */
export const AUDIT_INVENTORY_EXPORT_COLUMN_KEYS = new Set<InventoryReportingExportColumnKey>([
    'name',
    'manufacturerPartNumber',
    'locationTitle',
    'supplierName',
    'category',
    'unit',
    'bins',
    'tags',
    'partType',
    'businessLine',
    'adjustmentType',
    'quantity',
    'orderedAndInitialQuantity',
    'usedQuantity',
    'soldQuantity',
    'unitCost',
    'lineCost',
    'inStockQuantityAfter',
    'timestamp',
    'roNumber',
    'note',
    'targetQuantity',
    'reorderQuantity',
]);
